import Vue from 'vue';
import * as types from './types';

const mutations = {
  [types.RESET_STATE]() {
    // Object.assign(state, initialState);
  },
  // FETCH_INITIAL
  [types.FETCH_INITIAL_PENDING](state) {
    state.initialLoading = true;
  },
  [types.FETCH_INITIAL_FULFILLED](state) {
    state.initialLoading = false;
  },
  [types.FETCH_INITIAL_ERROR](state) {
    state.initialLoading = false;
  },
  [types.FETCH_PRODUCTS_FULFILLED](state, payload) {
    const productsBase = payload
      .filter((product) => product.type === 'base')
      .sort((a, b) => a.plans.monthly.amount - b.plans.monthly.amount);
    state.productsBase = productsBase;

    const productsAdditional = payload
      .filter((product) => product.type === 'additional')
      .sort((a, b) => a.plans.monthly.amount - b.plans.monthly.amount);
    state.productsAdditional = productsAdditional;
  },
  [types.FETCH_SUBSCRIPTIONS_FULFILLED](state, payload) {
    Vue.set(state, 'subscriptions', payload);
  },
  [types.FETCH_INVOICES_FULFILLED](state, payload) {
    Vue.set(state, 'invoices', payload);
  },
  // FETCH_INITIAL
  [types.FETCH_INITIAL_PENDING](state) {
    state.initialLoading = true;
  },
  [types.FETCH_INITIAL_FULFILLED](state) {
    state.initialLoading = false;
  },
  [types.FETCH_INITIAL_ERROR](state) {
    state.initialLoading = false;
  },
  // CHECK_COUPON_CODE
  [types.CHECK_COUPON_CODE_PENDING](state) {
    state.checkCouponCodePending = true;
  },
  [types.CHECK_COUPON_CODE_FULFILLED](state) {
    state.checkCouponCodePending = false;
  },
  [types.CHECK_COUPON_CODE_ERROR](state) {
    state.checkCouponCodePending = false;
  },
  // STORE_SUBSCRIPTION
  [types.STORE_SUBSCRIPTION_PENDING](state) {
    state.storeSubscriptionPending = true;
  },
  [types.STORE_SUBSCRIPTION_FULFILLED](state, payload) {
    Vue.set(state, 'subscriptions', payload);
    state.storeSubscriptionPending = false;
  },
  [types.STORE_SUBSCRIPTION_ERROR](state) {
    state.storeSubscriptionPending = false;
  },
  // STORE_COUPON_CODE
  [types.STORE_COUPON_CODE_PENDING](state) {
    state.storeSubscriptionCouponPending = true;
  },
  [types.STORE_COUPON_CODE_FULFILLED](state, payload) {
    Vue.set(state, 'subscriptions', payload);
    state.storeSubscriptionCouponPending = false;
  },
  [types.STORE_COUPON_CODE_ERROR](state) {
    state.storeSubscriptionCouponPending = false;
  },
  // STORE_ADDITIONAL_COMPANY
  [types.STORE_ADDITIONAL_COMPANY_PENDING](state) {
    state.storeAdditionalCompanyPending = true;
  },
  [types.STORE_ADDITIONAL_COMPANY_FULFILLED](state, payload) {
    Vue.set(state, 'subscriptions', payload);
    state.storeAdditionalCompanyPending = false;
  },
  [types.STORE_ADDITIONAL_COMPANY_ERROR](state) {
    state.storeAdditionalCompanyPending = false;
  },
  //  CHANGE_SUBSCRIPTION
  [types.CHANGE_SUBSCRIPTION_PENDING](state) {
    state.changeSubscriptionPending = true;
  },
  [types.CHANGE_SUBSCRIPTION_FULFILLED](state) {
    state.changeSubscriptionPending = false;
  },
  [types.CHANGE_SUBSCRIPTION_ERROR](state) {
    state.changeSubscriptionPending = false;
  },
  // CANCEL_SUBSCRIPTION
  [types.CANCEL_SUBSCRIPTION_PENDING](state) {
    state.cancelSubscriptionPending = true;
  },
  [types.CANCEL_SUBSCRIPTION_FULFILLED](state) {
    state.cancelSubscriptionPending = false;
  },
  [types.CANCEL_SUBSCRIPTION_ERROR](state) {
    state.cancelSubscriptionPending = false;
  },
  // CHANGE_CREDIT_CARD
  [types.CHANGE_CREDIT_CARD_PENDING](state) {
    state.changeCreditCardPending = true;
  },
  [types.CHANGE_CREDIT_CARD_FULFILLED](state, payload) {
    Vue.set(state, 'subscriptions', payload.data.data);
    state.changeCreditCardPending = false;
  },
  [types.CHANGE_CREDIT_CARD_ERROR](state) {
    state.changeCreditCardPending = false;
  },
  // FETCH_SUBSCRIPTION_PDF
  [types.FETCH_SUBSCRIPTION_PDF_PENDING](state) {
    state.fetchSubscriptionPdfPending = true;
  },
  [types.FETCH_SUBSCRIPTION_PDF_FULFILLED](state) {
    state.fetchSubscriptionPdfPending = false;
  },
  [types.FETCH_SUBSCRIPTION_PDF_ERROR](state) {
    state.fetchSubscriptionPdfPending = false;
  },
};

export default mutations;
